import React, { useState, useEffect, Fragment } from 'react';
import axios from 'axios';
import Box from '../../Box';
import Tools from '../../Tools';

import { ReactComponent as BackIcon } from '../../icons/back.svg';
import { ReactComponent as CallIcon } from '../../icons/call.svg';
import { ReactComponent as CallOffIcon } from '../../icons/callOff.svg';
import { ReactComponent as HangIcon } from '../../icons/hang.svg';
import { ReactComponent as MuteIcon } from '../../icons/mute.svg';
import { ReactComponent as UnmuteIcon } from '../../icons/unmute.svg';
import { ReactComponent as HoldIcon } from '../../icons/hold.svg';
import { ReactComponent as UnholdIcon } from '../../icons/unhold.svg';
import { ReactComponent as SearchIcon } from '../../icons/search.svg';
import { ReactComponent as CallWhatsappIcon } from '../../icons/whatsapp.svg';
import { useSoftphone } from '../../SoftphoneContext.jsx';



const ClientHeader = (props) => {

    const [client, setClient] = useState(props.client);

    //const [callStatus, setCallStatus] = useState('normal');
    const [softphone, setSoftphone] = useState({});
    const [muteStatus, setMuteStatus] = useState(false);
    const [showOtherPhoneNumbers, setShowOtherPhoneNumbers] = useState(false);
    const [otherPhoneNumbers, setOtherPhoneNumbers] = useState([]);
    const [phoneList, setPhoneList] = useState([]);
    const [showPhoneList, setShowPhoneList] = useState(false);
    const { incomingCallStatus, outgoingCallStatus } = useSoftphone();
    
    const whatsappMessage =(client)=>{
        axios.get(`http://10.0.0.168:3069/sendwsp`, {
            params: { phone: client.contacto.telefono1, name: `${client.clienteNombre} ${client.clienteApPat}`}
        })
        .then(function (response) {
            alert('Mensaje enviado');
        })
        .catch(function (error) {
            console.log("Error:", error.message);
        });
    }

    const Popover = (props) => {
        if (props.show) {
            return <div className={'popover ' + props.position} style={{ width: props.width }}>{props.children}</div>
        } else {
            return null;
        }
    }

    useEffect(() => {

        //build phoneList
        console.log('🐞DEBUG props.client.clientId:', props.client.contacto.celular);
        let phoneList=[];
        
        if (props.client.contacto.telefono1!==null && props.client.contacto.telefono1!=="null"){
            phoneList.push(props.client.contacto.telefono1);
        }
        if (props.client.contacto.telefono2!==null && props.client.contacto.telefono2!=="null"){
            phoneList.push(props.client.contacto.telefono2);
        }
        if (props.client.contacto.telefono3!==null && props.client.contacto.telefono3!=="null"){
            phoneList.push(props.client.contacto.telefono3);
        }
        if (props.client.contacto.telefono4!==null && props.client.contacto.telefono4!=="null"){
            phoneList.push(props.client.contacto.telefono4);
        }
        if (props.client.contacto.telefono5!==null && props.client.contacto.telefono5!=="null"){
            phoneList.push(props.client.contacto.telefono5);
        }
        if (props.client.contacto.telefono6!==null && props.client.contacto.telefono6!=="null"){
            phoneList.push(props.client.contacto.telefono6);
        }
        setPhoneList(phoneList);

        //SET DEFAULT CURRENTPHONE
        let updatedClient = Object.assign({}, props.client); 
        if(props.phone){
            updatedClient.currentPhone=props.phone;
        } else {
            updatedClient.currentPhone = Tools.getPriorityPhone(props.client.contacto);;  
        }
        props.updateClientMethod(updatedClient);
    }, []);

    return (
        <div className="flexRow headerClient">
            <div className="flexCol">

                <Box type="readOnly" className="" name="clientId" label="Rut" value={client.clientId}></Box>
                <Box type="readOnly" className="worb" name="phone" label={'Teléfono (' + phoneList.length + ')'} labelClassName={phoneList.length > 1 ? 'phoneListTrigger':null} value={props.client.currentPhone} showChildren={phoneList.length > 1}>
                    <div className='phoneList'>
                        <ul>
                            {phoneList.map((phone, index) => {
                                return (
                                    <li className={phone===props.client.currentPhone?'selected':undefined} key={index}><a key={index} onClick={() => { let updatedClient = Object.assign({}, props.client); updatedClient.currentPhone = phone; props.updateClientMethod(updatedClient)}}>{phone}</a></li>
                                );
                            })}
                        </ul>
                    </div>
                </Box>
                
                <div className="callContainer">
                    {/* <span className="wrapper rel">
                        <a tooltip="Buscar más teléfonos" onClick={() => getOtherPhoneNumbers()}><SearchIcon /></a>

                        <Popover show={showOtherPhoneNumbers} position='bottom'>
                            <table>
                                <thead>
                                    <tr><th>Campaña</th><th>Teléfono</th><th></th></tr>
                                </thead>
                                <tbody>
                                    {otherPhoneNumbers.map((listValue, index) => {
                                        return (
                                            <tr key={index}>
                                                <td>{listValue.company_name}</td>
                                                <td className="nowrap">{listValue.campaign_name}</td>
                                                <td>{listValue.phone}</td>
                                                <td><a className="noTransform" onClick={() => softphone.call(listValue.phone)}><CallIcon /></a></td>
                                            </tr>
                                        )
                                    })}
                                </tbody>
                            </table>
                        </Popover>
                    </span> */}

                    {props.softphoneSessionType === 'incoming' ? ( //INCOMING <<<== (ENTRANTE) 
                        <Fragment>
                            
                            {incomingCallStatus === 'incoming' ? (
                                <Fragment>
                                    <a className="ripple" tooltip="contestar" onClick={() => softphone.answerIncomingCall()}><CallIcon /></a>
                                    <a tooltip="Cortar" onClick={() => softphone.terminateCall()} ><HangIcon /></a>
                                </Fragment>
                            ):
                            incomingCallStatus === 'confirmed' ? (
                                <Fragment>
                                    <a tooltip="Colgar" onClick={() => softphone.terminateCall()} ><HangIcon /></a>
                                    {props.softphoneMuted ? (
                                        <a tooltip="desmutear" onClick={() => softphone.unmute()} ><UnmuteIcon /></a>
                                    ) : (
                                        <a tooltip="mutear" onClick={() => softphone.mute()} ><MuteIcon /></a>
                                    )}

                                    {props.softphoneHolded ? (
                                        <a tooltip="Salir de llamada en espera" onClick={() => softphone.unhold()} ><UnholdIcon /></a>
                                    ) : (
                                        <a tooltip="Llamada en espera" onClick={() => softphone.hold()} ><HoldIcon /></a>
                                    )}
                                </Fragment>

                            ) : null}
                        </Fragment>
                    ): //OUTGOING ==>>> (SALIDA) 
                        outgoingCallStatus === 'confirmed' ? (
                            <Fragment>
                            <a tooltip="colgar/cortar" onClick={() => softphone.terminateCall()} ><HangIcon /></a>
                            {props.softphoneMuted ? (
                                <a tooltip="desmutear" onClick={() => softphone.unmute()} ><UnmuteIcon /></a>
                            ) : (
                                <a tooltip="mutear" onClick={() => softphone.mute()} ><MuteIcon /></a>
                            )}

                            {props.softphoneHolded ? (
                                <a tooltip="Salir de llamada en espera" onClick={() => softphone.unhold()} ><UnholdIcon /></a>
                            ) : (
                                <a tooltip="Llamada en espera" onClick={() => softphone.hold()} ><HoldIcon /></a>
                            )}

                            </Fragment>
                        ):
                            outgoingCallStatus === 'peerconnection' || outgoingCallStatus === 'progress' ?
                        (
                            <Fragment>
                                {/* <a tooltip="llamando" className='ripple'><CallIcon /></a>  */}
                                <a tooltip="cortar llamada saliente" onClick={() => softphone.terminateCall()} ><HangIcon /></a>
                            </Fragment>
                        ):(
                            // <a tooltip="llamar al cliente" onClick={() => softphone.call(1002)}><CallIcon /></a> 
                            <Fragment>
                            <a tooltip="llamar al cliente" className='callIcon' onClick={() => softphone.call(props.client.currentPhone)}><CallOffIcon /></a> 
                            <a tooltip="Enviar whatsapp" className='callIcon' onClick={() => whatsappMessage(props.client)}><CallWhatsappIcon /></a> 
                            </Fragment>
                        )
                    }
                    
                </div>
                <Box type="readOnly" className="x4" name="address" label="Dirección" value={client.direccion.direccion + ' ' + client.direccion.numero + ', ' + client.direccion.comuna}></Box>
                <Box type="readOnly" className="x3" name="email" label="Email" value={client.contacto.email}></Box>
            </div>
        </div>
    );

}

export default ClientHeader;
